const Jobs = [
    {
        id:'1',
        title:'Bulkmatic',
        subtitle:'Pagina informática',
        img:'assets/img/portfolio/portfolio-1.jpg',
        filter:'col-lg-4 col-md-6 filter-prianti',
        description:'CUENTA CON SECCIÓN DE NOTICIAS, COMENTARIOS, GALERÍA, UBICACIONES, REALIZADO CON WordPress.',
        link:'https://prianti.mx/test/bulkmaticwww'
    },
    {
        id:'2',
        title:'Animal Karmas',
        subtitle:'OCR, RDE',
        img:'assets/img/portfolio/portfolio-2.jpg',
        filter:'col-lg-4 col-md-6 filter-freelance',
        description:'SISTEMA CON RECONOCIMIENTO DE IMÁGENES O VIDEOS, PARA CLASIFICAR ANIMALES CAPTURADOS EN CÁMARAS',
        link:'https://animalkarma.org.mx'
    }
];
export default Jobs;